import { createComponent } from './utils/create-component';
import Picker from './picker';
import propTypes from './utils/prop-types';
import { INPUT_EVENT, CHANGE_EVENT, CANCEL_EVENT, CONFIRM_EVENT, HIDE_EVENT, MASK_CLICK_EVENT } from './utils/constants';
import { ref, computed, watch, resolveComponent, openBlock, createElementBlock, normalizeClass, createVNode, withCtx, renderSlot } from 'vue';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var props = {
  // 显隐配置
  modelValue: propTypes["boolean"]().def(false),
  // 是否只读
  readonly: propTypes["boolean"]().def(false),
  // date-time picker 的生效类型
  type: propTypes.string().re(),
  // 默认选中值，支持数组与Date实例两种类型
  selectedValue: propTypes.oneOfType([propTypes.array(), propTypes.date()]).def(new Date()),
  // 最小可选中时间
  minDate: propTypes.date().def(new Date("".concat(new Date().getFullYear(), "/1/1 00:00:00"))),
  // 最大可选中时间
  maxDate: propTypes.date().def(new Date("".concat(new Date().getFullYear(), "/12/31 23:59:59"))),
  // 时间项单位
  unitText: propTypes.object(),
  // popup形式下显示的title
  title: propTypes.string().def(''),
  // popup形式下显示的取消文案
  cancelText: propTypes.string().def('取消'),
  // popup形式下显示的完成文案
  okText: propTypes.string().def('完成'),
  // 可支持配置的单个item normal selected 状态的行内样式
  itemStyles: propTypes.array().def([]),
  // 是否为视图模式
  isView: propTypes["boolean"]().def(false),
  // 是否支持mask关闭弹窗
  maskCloseable: propTypes["boolean"]().def(true),
  // 是否禁用外部滚动
  disableScroll: propTypes["boolean"]().def(true),
  // 是否需要底部安全区，只有popup形式支持
  needSafeArea: propTypes["boolean"]().def(true),
  // popup形式下取消前触发
  onBeforeCancel: propTypes["function"]().def(function () {
    return true;
  }),
  // popup形式下确认前触发
  onBeforeConfirm: propTypes["function"]().def(function () {
    return true;
  }),
  // 是否需要过滤
  filterable: propTypes["boolean"]().def(false),
  // 按照类型支持的过滤器
  filter: propTypes["function"](),
  // 支持按照类型进行格式化处理
  formatter: propTypes["function"](),
  // 默认时间类型，是按照当天、最小值、最大值取，默认为当天
  defaultDateType: propTypes.string().def('today')
};
var emits = [INPUT_EVENT, CHANGE_EVENT, CANCEL_EVENT, CONFIRM_EVENT, HIDE_EVENT, MASK_CLICK_EVENT];

var _DEFAULT_CONFIG, _TYPE_MATCHUP;
/**
 * @description: 月日时分秒默认配置
 */
var DEFAULT_CONFIG = (_DEFAULT_CONFIG = {}, _defineProperty(_DEFAULT_CONFIG, "MM", Array.from(new Array(12), function (_, i) {
  return i + 1;
}).map(function (value) {
  return {
    value: value,
    text: value
  };
})), _defineProperty(_DEFAULT_CONFIG, "dd", Array.from(new Array(31), function (_, i) {
  return i + 1;
}).map(function (value) {
  return {
    value: value,
    text: value
  };
})), _defineProperty(_DEFAULT_CONFIG, "hh", _toConsumableArray(new Array(24).keys()).map(function (value) {
  return {
    value: value,
    text: value
  };
})), _defineProperty(_DEFAULT_CONFIG, "mm", _toConsumableArray(new Array(60).keys()).map(function (value) {
  return {
    value: value,
    text: value
  };
})), _defineProperty(_DEFAULT_CONFIG, "ss", _toConsumableArray(new Array(60).keys()).map(function (value) {
  return {
    value: value,
    text: value
  };
})), _DEFAULT_CONFIG);
/**
 * @description: picker类型与列对应关系
 */
var TYPE_MATCHUP = (_TYPE_MATCHUP = {}, _defineProperty(_TYPE_MATCHUP, "date", ['yyyy', 'MM', 'dd']), _defineProperty(_TYPE_MATCHUP, "year-month", ['yyyy', 'MM']), _defineProperty(_TYPE_MATCHUP, "month-day", ['MM', 'dd']), _defineProperty(_TYPE_MATCHUP, "time", ['hh', 'mm', 'ss']), _defineProperty(_TYPE_MATCHUP, "hour-min", ['hh', 'mm']), _defineProperty(_TYPE_MATCHUP, "min-sec", ['mm', 'ss']), _defineProperty(_TYPE_MATCHUP, "date-time", ['yyyy', 'MM', 'dd', 'hh', 'mm', 'ss']), _defineProperty(_TYPE_MATCHUP, "date-hour-min", ['yyyy', 'MM', 'dd', 'hh', 'mm']), _TYPE_MATCHUP);
/**
 * @description: 日期类型的picker类型列表
 */
var DATE_TYPE_LIST = ['date', 'year-month', 'month-day', 'date-time', 'date-hour-min'];

var _GET_CONFIG_FN_MATCHU;
// 大月列表
var BIG_MONTH = [1, 3, 5, 7, 8, 10, 12];
// 获取配置方法对应关系
var GET_CONFIG_FN_MATCHUP = (_GET_CONFIG_FN_MATCHU = {}, _defineProperty(_GET_CONFIG_FN_MATCHU, "yyyy", getBetweenYears), _defineProperty(_GET_CONFIG_FN_MATCHU, "MM", getTargetMonths), _defineProperty(_GET_CONFIG_FN_MATCHU, "dd", getTargetDays), _defineProperty(_GET_CONFIG_FN_MATCHU, "hh", getTargetHours), _defineProperty(_GET_CONFIG_FN_MATCHU, "mm", getTargetMins), _defineProperty(_GET_CONFIG_FN_MATCHU, "ss", getTargetSecs), _GET_CONFIG_FN_MATCHU);
function getDateTypeDateArr(fullDateArr, dateTimePickerType) {
  var result = fullDateArr;
  switch (dateTimePickerType) {
    case 'date':
      result = result.slice(0, 3);
      break;
    case 'year-month':
      result = result.slice(0, 2);
      break;
    case 'month-day':
      result = result.slice(1, 3);
      break;
    case 'time':
      result = result.slice(3);
      break;
    case 'hour-min':
      result = result.slice(3, 5);
      break;
    case 'min-sec':
      result = result.slice(4);
      break;
    case 'date-time':
      result = fullDateArr;
      break;
    case 'date-hour-min':
      result = result.slice(0, 5);
      break;
  }
  return result;
}
/**
 * @description: 获取两个日期某列的相等关系
 * @param {Date} DateOne 需要判断的日期
 * @param {Date} DateTwo 被比较的日期
 * @param {DateTimeType} type 要判断的列类型
 * @return {*}
 */
function compareDate(dateOne, dateTwo, type) {
  var isEqual = false;
  var _formatDate = formatDate(dateOne),
    dateObjOne = _formatDate.dateObj;
  var _formatDate2 = formatDate(dateTwo),
    dateObjTwo = _formatDate2.dateObj;
  switch (type) {
    case 'yyyy':
      isEqual = dateObjOne.yyyy === dateObjTwo.yyyy;
      break;
    case 'MM':
      isEqual = dateObjOne.yM === dateObjTwo.yM;
      break;
    case 'dd':
      isEqual = dateObjOne.yMd === dateObjTwo.yMd;
      break;
    case 'hh':
      isEqual = dateObjOne.yMdh === dateObjTwo.yMdh;
      break;
    case 'mm':
      isEqual = dateObjOne.yMdhm === dateObjTwo.yMdhm;
      break;
  }
  return isEqual;
}
/**
 * @description: 将传入的Date拆分为dateObj & dateArr
 * @param {Date} date
 * @return {*}
 */
function formatDate(date) {
  var yyyy = date.getFullYear();
  var originalMM = date.getMonth();
  var MM = originalMM + 1;
  var dd = date.getDate();
  var hh = date.getHours();
  var mm = date.getMinutes();
  var ss = date.getSeconds();
  return {
    dateObj: {
      yyyy: yyyy,
      MM: MM,
      originalMM: originalMM,
      dd: dd,
      hh: hh,
      mm: mm,
      ss: ss,
      yM: "".concat(yyyy).concat(MM),
      yMd: "".concat(yyyy).concat(MM).concat(dd),
      yMdh: "".concat(yyyy).concat(MM).concat(dd).concat(hh),
      yMdhm: "".concat(yyyy).concat(MM).concat(dd).concat(hh).concat(mm)
    },
    dateArr: [yyyy, MM, dd, hh, mm, ss]
  };
}
/**
 * @description: 根据需要的类型，获取时间列数据
 * @param {Date} minDate 最小时间
 * @param {Date} maxDate 最大时间
 * @param {Date} currentDate 当前时间
 * @param {DateTimeType} dateTimeType 被比较的时间类型
 * @param {DateTimePickerNormalItem[]} defaultConfig 未比较前的时间配置项
 * @param {string} dateFnName 需要调用的时间函数名称
 * @param {number} charge 需要被补充的添加值，只有月需要+1
 * @return {*}
 */
function getDateTypeRange(minDate, maxDate, currentDate, dateTimeType, defaultConfig, dateFnName) {
  var charge = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var configStart = [],
    configEnd = [],
    target = defaultConfig;
  // 如果当前被比较的类型与最小一致，则取最小~默认配置最大
  if (compareDate(currentDate, minDate, dateTimeType)) {
    target = configStart = defaultConfig.filter(function (item) {
      return item.value >= minDate[dateFnName]() + charge;
    });
  }
  // 如果当前被比较的类型与最大一致，则取默认配置最小~最大
  if (compareDate(currentDate, maxDate, dateTimeType)) {
    target = configEnd = defaultConfig.filter(function (item) {
      return item.value <= maxDate[dateFnName]() + charge;
    });
  }
  // 如果既是最大又是最小，则取交集
  if (configStart.length && configEnd.length) {
    var configEndKeyList = configEnd.map(function (item) {
      return item.value;
    });
    return configStart.filter(function (config) {
      return configEndKeyList.includes(config.value);
    });
  }
  // 否则按照正常归属逻辑返回
  return target;
}
/**
 * @description: 根据月份不同，获取对应月默认的日期数
 * @param {Date} currentDate 当前选中的时间
 * @return {*}
 */
function getMonthDates(currentDate) {
  var end = 31;
  var currentMonth = currentDate.getMonth() + 1;
  if (currentMonth === 2) {
    // 闰月29 普通28
    end = isLeapYear(currentDate) ? 29 : 28;
  } else if (!BIG_MONTH.includes(currentMonth)) {
    // 非大月30
    end = 30;
  }
  return DEFAULT_CONFIG['dd'].slice(0, end);
}
/**
 * @description: 获取两个日期间的年份
 * @param {Date} minDate 最小日期
 * @param {Date} maxDate 最大日期
 * @return {*} 获取到的年份
 */
function getBetweenYears(minDate, maxDate) {
  var minYear = minDate.getFullYear();
  var maxYear = maxDate.getFullYear();
  var years = [];
  for (var i = minYear; i <= maxYear; i++) {
    years.push({
      text: i,
      value: i
    });
  }
  return years;
}
/**
 * @description: 获取月配置
 * @param {Date} minDate 最小日期
 * @param {Date} maxDate 最大日期
 * @param {Date} currentDate 当前日期
 * @return {*} 处理后的时间配置项组
 */
function getTargetMonths(minDate, maxDate, currentDate) {
  var defaultConfig = DEFAULT_CONFIG['MM'];
  return getDateTypeRange(minDate, maxDate, currentDate, 'yyyy', defaultConfig, 'getMonth', 1);
}
/**
 * @description: 获取日配置
 * @param {Date} minDate 最小日期
 * @param {Date} maxDate 最大日期
 * @param {Date} currentDate 当前日期
 * @return {*} 处理后的时间配置项组
 */
function getTargetDays(minDate, maxDate, currentDate) {
  var defaultConfig = getMonthDates(currentDate);
  return getDateTypeRange(minDate, maxDate, currentDate, 'MM', defaultConfig, 'getDate');
}
/**
 * @description: 获取时配置
 * @param {Date} minDate 最小日期
 * @param {Date} maxDate 最大日期
 * @param {Date} currentDate 当前日期
 * @return {*} 处理后的时间配置项组
 */
function getTargetHours(minDate, maxDate, currentDate) {
  var defaultConfig = DEFAULT_CONFIG['hh'];
  return getDateTypeRange(minDate, maxDate, currentDate, 'dd', defaultConfig, 'getHours');
}
/**
 * @description: 获取分配置
 * @param {Date} minDate 最小日期
 * @param {Date} maxDate 最大日期
 * @param {Date} currentDate 当前日期
 * @return {*} 处理后的时间配置项组
 */
function getTargetMins(minDate, maxDate, currentDate) {
  var defaultConfig = DEFAULT_CONFIG['mm'];
  return getDateTypeRange(minDate, maxDate, currentDate, 'hh', defaultConfig, 'getMinutes');
}
/**
 * @description: 获取秒配置
 * @param {Date} minDate 最小日期
 * @param {Date} maxDate 最大日期
 * @param {Date} currentDate 当前日期
 * @return {*} 处理后的时间配置项组
 */
function getTargetSecs(minDate, maxDate, currentDate) {
  var defaultConfig = DEFAULT_CONFIG['ss'];
  return getDateTypeRange(minDate, maxDate, currentDate, 'mm', defaultConfig, 'getSeconds');
}
/**
 * @description: 补全时间位数并进行转换
 * @param {DateTimePickerType} dateTimePickerType pickerType类型
 * @param {number} selectedValue 用户选中的时间数组
 * @param {Date} initDate 初始化时间，会进行补位
 * @return {*}
 */
function completeDateDigits(dateTimePickerType, selectedValue, initDate) {
  var _formatDate3 = formatDate(initDate),
    dateObj = _formatDate3.dateObj;
  var yyyy = dateObj.yyyy,
    dd = dateObj.dd,
    hh = dateObj.hh,
    mm = dateObj.mm,
    ss = dateObj.ss;
  var dateStr = '';
  switch (dateTimePickerType) {
    case 'date':
      dateStr = "".concat(selectedValue[0], "/").concat(selectedValue[1], "/").concat(selectedValue[2], " ").concat(hh, ":").concat(mm, ":").concat(ss);
      break;
    case 'year-month':
      dateStr = "".concat(selectedValue[0], "/").concat(selectedValue[1], "/").concat(dd, " ").concat(hh, ":").concat(mm, ":").concat(ss);
      break;
    case 'month-day':
      dateStr = "".concat(yyyy, "/").concat(selectedValue[0], "/").concat(selectedValue[1], " 00:00:00");
      break;
    case 'date-time':
      dateStr = "".concat(selectedValue[0], "/").concat(selectedValue[1], "/").concat(selectedValue[2], " ").concat(selectedValue.slice(3).join(':'));
      break;
    case 'date-hour-min':
      dateStr = "".concat(selectedValue[0], "/").concat(selectedValue[1], "/").concat(selectedValue[2], " ").concat(selectedValue.slice(3).join(':'), ":").concat(ss);
      break;
    // 非時間類型不涉及補足
    // case 'time':
    //     dateStr = `${yyyy}/${MM}/${dd} 00:00:00`;
    //     break;
    // case 'hour-min':
    //     dateStr = `${yyyy}/${MM}/${dd} ${selectedValue.join(':')}:${ss}`;
    //     break;
    // case 'min-sec':
    //     dateStr = `${yyyy}/${MM}/${dd} ${hh}:${selectedValue.join(':')}`;
    //     break;
    // 默认值不做jest验证
    /* istanbul ignore next */
    default:
      dateStr = '';
  }
  // 增加超出时间判断，如果new Date 后的时间与字符串的月份不一致，则回退时间
  var _dateStr$split = dateStr.split(' '),
    _dateStr$split2 = _slicedToArray(_dateStr$split, 2),
    ymd = _dateStr$split2[0],
    others = _dateStr$split2[1];
  var _ymd$split = ymd.split('/'),
    _ymd$split2 = _slicedToArray(_ymd$split, 3),
    year = _ymd$split2[0],
    month = _ymd$split2[1],
    date = _ymd$split2[2];
  if (new Date(dateStr).getMonth() + 1 !== +month) {
    for (var i = 1; i < 5; i++) {
      dateStr = "".concat(year, "/").concat(month, "/").concat(+date - i, " ").concat(others);
      if (new Date(dateStr).getMonth() + 1 === +month) {
        break;
      }
    }
  }
  return {
    str: dateStr,
    date: new Date(dateStr)
  };
}
/**
 * @description 是否为闰年 置闰法则： 四年一闰；百年不闰，四百年再闰
 * @date 2022-04-19
 * @param {Date} currentDate 当前日期
 * @return {*}  {boolean} 是否为闰年
 */
function isLeapYear(currentDate) {
  var isLeap = false;
  if (currentDate.getFullYear() % 100 === 0) {
    if (currentDate.getFullYear() % 400 === 0) {
      isLeap = true;
    }
  } else if (currentDate.getFullYear() % 4 === 0) {
    isLeap = true;
  }
  return isLeap;
}

var _createComponent = createComponent('date-time-picker'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  props: props,
  components: _defineProperty({}, Picker.name, Picker),
  emits: emits,
  setup: function setup(props, _ref) {
    var _DEFAULT_DATE;
    var emit = _ref.emit;
    // 用户选中的值
    var pickerSelectedValue = ref([]);
    // picker列配置项
    var pickerConfig = ref([]);
    // 是否展示picker
    var isShowPicker = computed({
      get: function get() {
        return props.modelValue;
      },
      set: function set(isShow) {
        emit(INPUT_EVENT, isShow);
      }
    });
    // 是否需要进行filter
    var isNeedFilter = computed(function () {
      return props.filter && typeof props.filter === 'function';
    });
    // 根据传入类型判断，是否为需要日期类型
    var isDateType = computed(function () {
      return DATE_TYPE_LIST.includes(props.type);
    });
    // 用户传入的默认选中项是否为Date类型
    var isSelectedValueDateType = computed(function () {
      return props.selectedValue instanceof Date;
    });
    // 默认补充位数的日期，如果是默认传入Date类型则取默认，否则按照当前时间补全
    var defaultDate = computed(function () {
      return isSelectedValueDateType.value ? props.selectedValue : new Date();
    });
    // 默认时间的对应关系
    var DEFAULT_DATE = (_DEFAULT_DATE = {}, _defineProperty(_DEFAULT_DATE, 'today', defaultDate.value), _defineProperty(_DEFAULT_DATE, 'min-date', props.minDate), _defineProperty(_DEFAULT_DATE, 'max-date', props.maxDate), _DEFAULT_DATE);
    function init() {
      // 初始化选中结果
      var selectedValue = getSelectedValue();
      // 初始化配置项
      var configData = getConfigData(selectedValue);
      pickerConfig.value = configData;
      pickerSelectedValue.value = selectedValue;
    }
    /**
     * @description: 根据用户传入选中结果，初始化选中值
     * @param {*}
     * @return {*}
     */
    function getSelectedValue() {
      /**
       * 判断顺序：
       * 1. 如果数组类型且有值，不做边界判断，直接置入；
       * 2.1 如果时间对象类型，则取到Date类型
       * 2.2 如果数组类型且没值，根据用户所需配置类型取默认Date选择；
       * 2.3 根据取到的Date类型，与最大最小时间做判断，如果传入的小于/大于边界值，就赋为边界值
       */
      // 如果是数组类型且有值则直接注入，否则根据默认值获取一次
      if (Array.isArray(props.selectedValue) && props.selectedValue.length) {
        return _toConsumableArray(props.selectedValue);
      } else {
        // 非数组类型，先判断如果是时间对象类型就直接取，否则按照默认对象类型获取
        var targetDate;
        if (props.selectedValue instanceof Date) {
          targetDate = props.selectedValue;
        } else {
          targetDate = DEFAULT_DATE[props.defaultDateType];
        }
        // 增加最大最小边界值的判断逻辑，如果传入的小于/大于边界值，就赋为边界值
        if (+targetDate < +props.minDate) {
          targetDate = props.minDate;
        } else if (+targetDate > +props.maxDate) {
          targetDate = props.maxDate;
        }
        var _formatDate = formatDate(targetDate),
          dateArr = _formatDate.dateArr;
        return _toConsumableArray(getDateTypeDateArr(dateArr, props.type));
      }
    }
    /**
     * @description: 初始化配置项，默认根据用户当前选项进行处理
     */
    function getConfigData(selectedValue) {
      return getPickerConfig(selectedValue);
    }
    /**
     * @description: 获取picker列的配置项信息
     * @param {*} currentSelect 当前用户选中的数据
     * @return {*}
     */
    function getPickerConfig(currentSelect) {
      var middleData = [];
      // 获取原始数据源
      middleData = TYPE_MATCHUP[props.type].map(function (col) {
        return getColData(col, currentSelect);
      });
      // 如果存在filter、unit-text、formatter，则进行处理
      middleData = TYPE_MATCHUP[props.type].map(function (type, index) {
        var middleColData = middleData[index];
        // 执行逻辑，先filter再format，内部判断是否需要进行
        middleColData = colDataFormat(colDataFilter(middleColData, type), type);
        return middleColData;
      });
      return middleData;
    }
    /**
     * @description: 获取每一列的配置信息
     * @param {DateTimeType} colName 目标列的名称
     * @param {number[]} currentSelect 当前的选中值
     * @return {*}
     */
    function getColData(colName, currentSelect) {
      // 非年份类型，直接返回配置即可
      if (!isDateType.value) {
        return DEFAULT_CONFIG[colName];
      }
      // 否则按照对应列进行获取配置
      return GET_CONFIG_FN_MATCHUP[colName](props.minDate, props.maxDate, completeDateDigits(props.type, currentSelect, defaultDate.value).date);
    }
    /**
     * @description: 列filter调用
     * @param {DateTimePickerNormalItem[]} colData 单列数据配置项
     * @param {DateTimeType} type 该列的类型
     * @return {*}
     */
    function colDataFilter(colData, type) {
      return isNeedFilter.value ? colData.filter(function (item) {
        return props.filter && props.filter(type, item.value);
      }) : colData;
    }
    /**
     * @description: 列format调用
     * @param {DateTimePickerNormalItem[]} colData 单列数据配置项
     * @param {DateTimeType} type 该列的类型
     * @return {*}
     */
    function colDataFormat(colData, type) {
      var _getFormatInfo = getFormatInfo(type),
        isNeed = _getFormatInfo.isNeed,
        formatType = _getFormatInfo.formatType;
      if (isNeed) {
        return formatType === 'unitText' ? colData.map(function (item) {
          return _objectSpread2(_objectSpread2({}, item), {}, {
            text: "".concat(item.text).concat(props.unitText && props.unitText[type])
          });
        }) : colData.map(function (item) {
          return _objectSpread2(_objectSpread2({}, item), {}, {
            text: props.formatter && props.formatter(type, item.text)
          });
        });
      } else {
        return colData;
      }
    }
    /**
     * @description: 获取是否需要进行format信息
     * @param {DateTimeType} colName 列类型名称
     * @return {*}
     */
    function getFormatInfo(colName) {
      var info = {
        isNeed: false,
        formatType: ''
      };
      if (props.formatter && typeof props.formatter === 'function') {
        info.isNeed = true;
        info.formatType = 'format';
      }
      if (props.unitText && props.unitText[colName]) {
        info.isNeed = true;
        info.formatType = 'unitText';
      }
      return info;
    }
    /**
     * @description: 选中数据change时触发
     * @param {*} values 当前picker的选中值
     * @return {*}
     */
    function onPickerChange(values) {
      // 获取最终配置配置
      pickerConfig.value = getPickerConfig(values);
      // 赋最终选中值
      pickerSelectedValue.value = values;
      // 增加全量外抛参数
      var fullData = {
        date: completeDateDigits(props.type, values, defaultDate.value).date,
        arr: values
      };
      if (isDateType.value && isSelectedValueDateType.value) {
        emit(CHANGE_EVENT, fullData.date, fullData);
      } else {
        emit(CHANGE_EVENT, values, fullData);
      }
    }
    /**
     * @description: 取消事件触发
     */
    function onCancelClick() {
      emit(CANCEL_EVENT);
    }
    /**
     * @description: 确认事件触发
     * @param {*} values 当前picker的选中值
     * @return {*}
     */
    function onConfirmClick(values) {
      // 增加全量外抛参数
      var fullData = {
        date: completeDateDigits(props.type, values, defaultDate.value).date,
        arr: values
      };
      if (isDateType.value && isSelectedValueDateType.value) {
        emit(CONFIRM_EVENT, fullData.date, fullData);
      } else {
        emit(CONFIRM_EVENT, values, fullData);
      }
    }
    /**
     * @description: 当popup隐藏时触发
     */
    function onPopupHide() {
      emit(HIDE_EVENT);
    }
    /**
     * @description: 当popup mask被点击时触发
     */
    function onPopupMaskClick() {
      emit(MASK_CLICK_EVENT);
    }
    watch(function () {
      return props.modelValue;
    }, function (newVal) {
      if (newVal) {
        // 显隐发生变化时，进行初始化
        init();
      }
    }, {
      immediate: true
    });
    watch(function () {
      return props.selectedValue;
    }, function () {
      // 选中值发生变化时，进行初始化
      init();
    }, {
      immediate: true,
      deep: true
    });
    return {
      pickerSelectedValue: pickerSelectedValue,
      isShowPicker: isShowPicker,
      className: className,
      pickerConfig: pickerConfig,
      onPickerChange: onPickerChange,
      onCancelClick: onCancelClick,
      onConfirmClick: onConfirmClick,
      onPopupHide: onPopupHide,
      onPopupMaskClick: onPopupMaskClick
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_picker = resolveComponent("sp-picker");
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.className)
  }, [createVNode(_component_sp_picker, {
    modelValue: _ctx.isShowPicker,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.isShowPicker = $event;
    }),
    data: _ctx.pickerConfig,
    value: _ctx.isShowPicker,
    readonly: _ctx.readonly,
    cols: _ctx.pickerConfig.length,
    selectedValue: _ctx.pickerSelectedValue,
    title: _ctx.title,
    "cancel-text": _ctx.cancelText,
    "ok-text": _ctx.okText,
    "item-styles": _ctx.itemStyles,
    "is-view": _ctx.isView,
    "mask-closable": _ctx.maskCloseable,
    "disable-scroll": _ctx.disableScroll,
    "need-safe-area": _ctx.needSafeArea,
    "on-before-cancel": _ctx.onBeforeCancel,
    "on-before-confirm": _ctx.onBeforeConfirm,
    onChange: _ctx.onPickerChange,
    onCancel: _ctx.onCancelClick,
    onConfirm: _ctx.onConfirmClick,
    onHide: _ctx.onPopupHide,
    onMaskClick: _ctx.onPopupMaskClick
  }, {
    "customized-middle-part": withCtx(function () {
      return [renderSlot(_ctx.$slots, "customized-middle-part")];
    }),
    "customized-bottom-part": withCtx(function () {
      return [renderSlot(_ctx.$slots, "customized-bottom-part")];
    }),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["modelValue", "data", "value", "readonly", "cols", "selectedValue", "title", "cancel-text", "ok-text", "item-styles", "is-view", "mask-closable", "disable-scroll", "need-safe-area", "on-before-cancel", "on-before-confirm", "onChange", "onCancel", "onConfirm", "onHide", "onMaskClick"])], 2 /* CLASS */);
}

script.render = render;
script.__file = "components/src/component/date-time-picker/date-time-picker.vue";

var _DateTimePicker = script;

export { _DateTimePicker as default };
